var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$router.history.current.name !== 'login' && _vm.$router.history.current.name !== 'signup')?_c('div',{staticClass:"previous-button-main"},[_c('div',{staticClass:"previous-button-main-back-button",attrs:{"tabindex":"0"},on:{"click":function($event){_vm.profileEditable
				? _vm.toggleEditProfile($event)
				: _vm.addressOpen
				? _vm.toggleAddressForm($event)
				: _vm.createAccountOpen
				? _vm.toggleCreateAccountOpen()
				: _vm.goToPreviousRoute()}}},[_vm._v(" "+_vm._s(_vm.$t('general.previousPage'))+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }